import { c as _c } from "react/compiler-runtime";
import React from 'react';
export interface ItemIntegrationParamsProps {
  params: {
    title: React.ReactNode;
    value: React.ReactNode;
  }[];
}
export function ItemIntegrationParams(props) {
  const $ = _c(4);
  let t0;
  if ($[0] !== props.params) {
    t0 = props.params.map(_temp);
    $[0] = props.params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="flex flex-col gap-2.5 lg:gap-4">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(param, index) {
  return <div key={index} className="flex gap-2"><span>{param.title}:</span><span className="text-text-primary">{param.value}</span></div>;
}